<script>
import { ref } from 'vue';
import { mapGetters } from 'vuex';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useConversationLabels } from 'dashboard/composables/useConversationLabels';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import Spinner from 'shared/components/Spinner.vue';
import AddLabel from 'shared/components/ui/dropdown/AddLabel.vue';
import LabelManager from 'dashboard/components/LabelManager.vue';

export default {
  components: {
    Spinner,
    AddLabel,
    LabelManager,
  },
  setup() {
    const { isAdmin } = useAdmin();

    const { activeLabels, removeLabelFromConversation } = useConversationLabels();

    const showLabelManager = ref(false);
    const openLabelManager = () => {
      showLabelManager.value = true;
    };

    const keyboardEvents = {
      KeyL: {
        action: e => {
          e.preventDefault();
          openLabelManager();
        },
      },
      Escape: {
        action: () => {
          showLabelManager.value = false;
        },
        allowOnFocusedInput: true,
      },
    };
    useKeyboardEvents(keyboardEvents);

    return {
      isAdmin,
      activeLabels,
      removeLabelFromConversation,
      showLabelManager,
      openLabelManager,
    };
  },
  computed: {
    ...mapGetters({
      conversationUiFlags: 'conversationLabels/getUIFlags',
    }),
  },
};
</script>

<template>
  <div class="sidebar-labels-wrap">
    <div
      v-if="!conversationUiFlags.isFetching"
      class="contact-conversation--list"
    >
      <div class="label-wrap flex flex-wrap">
        <AddLabel @add="openLabelManager" />
        <woot-label
          v-for="label in activeLabels"
          :key="label.id"
          :title="label.title"
          :description="label.description"
          show-close
          :color="label.color"
          variant="smooth"
          class="max-w-[calc(100%-0.5rem)]"
          @remove="removeLabelFromConversation"
        />
      </div>
      <LabelManager v-model:show="showLabelManager" />
    </div>
    <Spinner v-else />
  </div>
</template>

<style lang="scss" scoped>
.sidebar-labels-wrap {
  margin-bottom: 0;
}
.contact-conversation--list {
  width: 100%;

  .label-wrap {
    line-height: 1.5rem;
    position: relative;
  }
}
</style>
